var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87_4698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9756 0H4.02445C1.80181 0 0 1.80181 0 4.02445V40.9756C0 43.1982 1.80181 45 4.02445 45H40.9756C43.1982 45 45 43.1982 45 40.9756V4.02445C45 1.80181 43.1982 0 40.9756 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1106 29.3303L32.1118 29.3289C33.6832 27.4852 34.6198 25.0967 34.6198 22.4999C34.6198 16.668 29.8776 11.9566 24.049 11.9555C24.0487 11.9555 24.0485 11.9555 24.0483 11.9555H24.0469L13.9309 11.9271L13.5038 11.9259V12.3529V32.6484V33.0742H13.9297H24.0767C26.978 33.0742 29.6068 31.8946 31.5108 29.9617C31.7121 29.7604 31.9243 29.5469 32.1106 29.3303ZM24.0455 28.6267H17.9485V16.4327H24.0455C27.4046 16.4327 30.1425 19.1706 30.1425 22.5297C30.1425 25.8889 27.4046 28.6267 24.0455 28.6267Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.851735
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87_4698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.33fd9fa135511720aa6d1c877ccffbcd.svg";
export { ForwardRef as ReactComponent };